import { render, staticRenderFns } from "./GameFeedback.vue?vue&type=template&id=5951a5f2&scoped=true"
import script from "./GameFeedback.vue?vue&type=script&lang=js"
export * from "./GameFeedback.vue?vue&type=script&lang=js"
import style0 from "./GameFeedback.vue?vue&type=style&index=0&id=5951a5f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5951a5f2",
  null
  
)

export default component.exports